import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import Loading from "../../components/Loading";
import auth from "../Firebase/firebase.init";
import useAdmin from "../../hooks/useAdmin";
import { toast } from "react-hot-toast";

const RequireAdmin = ({ children }: any) => {
  const [user, loading] = useAuthState(auth);
  const [admin, adminLoading] = useAdmin(user);
  const location = useLocation();

  if (loading || adminLoading) {
    return <Loading />;
  }

  if (!user || !admin) {
    signOut(auth);
    toast.error("You are not authorized to access this page!", {
      duration: 3000,
    });
    return <Navigate to="/login" state={{ from: location }} replace></Navigate>;
  }
  return children;
};

export default RequireAdmin;
